      import React from 'react'
      import img1 from "./about.jpg";

      const About = () => {
        return (
          <> 


                              <section className="about-heading">
                                <img src={img1}/>

                                <h2>About Us</h2>
                                  <p>Eat now is one of the most comprehensive and user-friendly apps where people can search for nearby restaurants and cafés, order food online, and get it delivered at their doorstep in no time. Moreover, you can also get accurate information about restaurants as it provides menus, reviews, and ratings. Based on that, users can place orders and enjoy lip-smacking food at their homes, <span>Eat now provides information, menus and user-reviews of restaurants as well as food delivery options from partner restaurants in select cities.</span></p>
                                  </section>
                      
                                  
                              </>
        )
      }
        
      export default About;
